import React, { useEffect, useState } from "react";
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

import AppRoutes from './Routes/index';
import ScrollToTopButton from './helpers/scrollToTopButton';
import SplashScreen from "./components/SplashScreen";

// Required imports for detecting /splash and auto-redirect
import { useLocation, useNavigate } from 'react-router-dom';

function App() {
  const [loading, setLoading] = useState(true);
  
  // For detecting current path and navigation
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has already seen the splash in this session
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');

    if (hasSeenSplash) {
      // Already seen → skip splash immediately
      setLoading(false);
    } else {
      // First time in this session → show splash for 3.2 seconds
      const timer = setTimeout(() => {
        setLoading(false);
        // Mark as seen so refresh won't show splash again
        sessionStorage.setItem('hasSeenSplash', 'true');
      }, 3200);

      return () => clearTimeout(timer);
    }
  }, []);

  // Auto-redirect from /splash back to home after animation
  // Only runs when NOT in initial loading phase
  useEffect(() => {
    if (!loading && location.pathname === '/splash') {
      const redirectTimer = setTimeout(() => {
        navigate('/', { replace: true });
      }, 3200); // Matches your splash duration

      return () => clearTimeout(redirectTimer);
    }
  }, [loading, location.pathname, navigate]);

  if (loading) {
    return <SplashScreen />; // Show splash screen first time only
  }

  // IMPORTANT: Hide ScrollToTopButton and ToastContainer on splash route
  const isSplash = location.pathname === '/splash';

  return (
    <div 
      style={{ 
        backgroundColor: 'white',
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0 
      }}
    >
      <main 
        style={{
          backgroundColor: 'white',
          minHeight: '100vh',
          width: '100%'
        }}
      >
        <AppRoutes />
        
        {/* Toastify - Hide on splash screen */}
        {!isSplash && (
          <ToastContainer 
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        )}
      </main>

      {/* ScrollToTopButton - Hide on splash screen */}
      <ScrollToTopButton/>
      <ToastContainer />

      {/* Second ToastContainer - Hide on splash screen */}
      {/* Note: You had two ToastContainers — usually one is enough */}
      {/* {!isSplash && <ToastContainer />} */}
    </div>
  );
}

export default App;